/**
 * API client for leaderboard data
 * All data fetched from backend API endpoints
 * NO direct access to Lexicon Proxy
 */

import { config } from '../config';
import type { LeaderboardChallengesResponse, LeaderboardStatsResponse } from '../types';

/**
 * Fetch overall leaderboard statistics
 */
export async function fetchLeaderboardStats(): Promise<LeaderboardStatsResponse> {
  const response = await fetch(`${config.apiUrl}/api/leaderboard/stats`);

  if (!response.ok) {
    throw new Error(`Failed to fetch stats: ${response.statusText}`);
  }

  return response.json();
}

/**
 * Fetch challenge rankings with question counts
 */
export async function fetchChallengeRankings(): Promise<LeaderboardChallengesResponse> {
  const response = await fetch(`${config.apiUrl}/api/leaderboard/challenges`);

  if (!response.ok) {
    throw new Error(`Failed to fetch challenge rankings: ${response.statusText}`);
  }

  return response.json();
}
